import { useInvoiceReportJournalEntries } from '@/context/services/invoice_reports/InvoiceReportJournal.service';
import type { InvoiceReportDetailJournalEntriesResponse } from 'ap-openapi';
import { useMemo } from 'react';

export const useJournalEntries = (reportId: string) => {
  const { data } = useInvoiceReportJournalEntries(reportId);
  const listColumns = useMemo(() => {
    return data?.entry_fields ?? [];
  }, [data]);

  const items = useMemo(() => {
    const source: InvoiceReportDetailJournalEntriesResponse =
      data?.entries ?? [];
    return source.map((item, index: number) => ({
      ...item,
      id: `${reportId}-${index}`,
    }));
  }, [data, reportId]);

  return { data: items, listColumns };
};

export const useDefaultPagination = () => {
  return useMemo(
    () => ({
      currentPage: 1,
      maxPage: 1,
      perPage: 1,
      maxRecord: 0,
    }),
    []
  );
};
